import(/* webpackMode: "eager" */ "/vercel/path0/app/(app)/dashboard/page.tsx");
